import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Upload } from 'lucide-react';
import { VolumeMetadataPanel } from './VolumeMetadataPanel';
/**
 * Workspace for "fill out this attachment and submit it" volumes — DD
 * forms, fillable PDFs, government-provided DOCX templates, and the
 * "Solicitation, Offer and Award + Reps & Certs" volume.
 *
 * Layout: VolumeMetadataPanel at the top (header + restrictions + multiple
 * source templates), then an upload dropzone placeholder. Linking the
 * uploaded filled version back to the volume ships after PR9.
 */ export function TemplateWorkspace({ projectId, volume }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-full flex-col bg-slate-50",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex-1 overflow-auto",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "mx-auto w-full max-w-3xl p-4 sm:p-6 lg:p-8",
                children: [
                    /*#__PURE__*/ _jsx(VolumeMetadataPanel, {
                        projectId: projectId,
                        volume: volume
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mt-6 rounded-xl border border-dashed border-slate-300 bg-white px-6 py-8 text-center",
                        children: [
                            /*#__PURE__*/ _jsx(Upload, {
                                className: "mx-auto h-8 w-8 text-slate-300",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mt-3 text-sm font-medium text-slate-700",
                                children: "Upload your filled version"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mt-1 text-xs text-slate-500",
                                children: [
                                    "Drag the completed file here once you’ve filled it out. Linking the upload back to this volume ships after PR9 — for now, upload via",
                                    ' ',
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "font-semibold",
                                        children: "Sources / Files"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
